module.exports = __webpack_public_path__ + "img/Tractor.18e07826.png";